'use strict';

module.exports = require('./lib/React');



//////////////////
// WEBPACK FOOTER
// ./~/_react@15.6.1@react/react.js
// module id = 2
// module chunks = 1